module.exports = __webpack_public_path__ + "img/N3F2_new.7e46a8cf.jpg";